import { render, staticRenderFns } from "./editPerson.vue?vue&type=template&id=d076ab9c&scoped=true"
import script from "./editPerson.vue?vue&type=script&lang=js"
export * from "./editPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d076ab9c",
  null
  
)

export default component.exports